// extracted by mini-css-extract-plugin
module.exports = {"text":"_1_taFsfPM-hwnxa1MpMCpJ"};